export default "__VITE_ASSET__Dauus61p__"